module.exports = __webpack_public_path__ + "static/media/gr6-newsletter-1.6ee200ca.pdf";